import { Drawer } from 'antd';
import styles from './CourseDetailsDrawer.module.scss';
import classNames from 'classnames';

export interface CourseDrawerItem {
	id: number;
	title: string;
	image: string;
	tags: string[];
	status?: 'Completed' | 'In Progress' | 'Not Started';
}

interface CourseDetailsDrawerProps {
	visible: boolean;
	course: CourseDrawerItem | null;
	onClose: () => void;
}

const CourseDetailsDrawer: React.FC<CourseDetailsDrawerProps> = ({
	visible,
	course,
	onClose
}) => {
	return (
		<Drawer
			className={styles.courseDetailsDrawer}
			placement="right"
			visible={visible}
			width={420}
			onClose={onClose}
			title={
				<div className={styles.drawerTitle}>
					<div className={styles.drawerTitle__name}>
						{course?.title ?? 'Course Title'}
					</div>
					<div className={styles.drawerTitle__badges}>
						<span
							className={classNames(
								styles.drawerTag,
								styles['drawerTag--ongoing']
							)}
						>
							Ongoing
						</span>
						<span
							className={classNames(styles.drawerTag, {
								[styles['drawerTag--completed']]:
									course?.status === 'Completed',
								[styles['drawerTag--inProgress']]:
									course?.status === 'In Progress',
								[styles['drawerTag--notStarted']]:
									!course?.status ||
									course?.status === 'Not Started'
							})}
						>
							{course?.status ?? 'Not Started'}
						</span>
					</div>
				</div>
			}
		>
			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Details</div>
				<div className={styles.subSection}>
					<div className={styles.detailLine}>Assignment #: 12131</div>
					<div className={styles.detailLine}>Created: 2/10/2025</div>
					<div className={styles.detailLine}>Updated: 5/10/2025</div>
					<div className={styles.detailLine}>Start: 10/10/2025</div>
					<div className={styles.detailLine}>
						Duration: 120 minutes
					</div>
				</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Details</div>
				----------
				{/* <div className={styles.detailPlaceholder} />
				<div className={styles.detailPlaceholder} />
				<div className={styles.detailPlaceholder} /> */}
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Assignment</div>
				<div className={styles.subSection}>
					<div className={styles.detailLine}>
						Housekeeping (36 users)
					</div>
					<div className={styles.detailLine}>
						Human Resources (20 users)
					</div>
				</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Scheduling</div>
				<div className={styles.subSection}>
					<div className={styles.detailLine}>Due: None</div>
					<div className={styles.detailLine}>
						Certification expiration: 1 year
					</div>
				</div>
			</div>

			<div className={styles.drawerSection}>
				<div className={styles.drawerSection__heading}>Languages</div>
				<div className={styles.languageWrap}>
					{[
						'Spanish',
						'English',
						'Arabic',
						'Chinese',
						'Italian',
						'French',
						'German'
					].map((lang) => (
						<span key={lang} className={styles.languageTag}>
							{lang}
						</span>
					))}
				</div>
			</div>
		</Drawer>
	);
};

export default CourseDetailsDrawer;
